import { useAtom } from 'jotai'
import { atomWithStorage, createJSONStorage } from 'jotai/utils'

const DEVTOOLS_STORAGE_KEY = 'devtools'

interface DevtoolsOptions {
    isTanstackRouterEnabled: boolean
    isTanstackQueryEnabled: boolean
}

const devtoolsStorage = createJSONStorage<DevtoolsOptions>(() => localStorage)

const devtoolsAtom = atomWithStorage<DevtoolsOptions>(
    DEVTOOLS_STORAGE_KEY,
    {
        isTanstackRouterEnabled: false,
        isTanstackQueryEnabled: false,
    },
    devtoolsStorage,
    {
        getOnInit: true,
    }
)

export const useDevtoolsOptions = () => {
    const [options, setOptions] = useAtom(devtoolsAtom)

    return { options, setOptions }
}
